export default __webpack_public_path__ + "static/media/pool_kits_2_xs.52c3d56d.png";